export default "__VITE_ASSET__C4c61maO__"